<template>
  <div class="container">
    <BaseFrame
    @setAble="setAble"
    :infos="infos"
    :idText = 'idText'
    :able="able"
    @save='submit("roleForm.sysRole")'
    @clear='showClear=true'
    @cancel='$router.push(-1)'
    saveText='保存'
    :logText="$route.name === 'roleInfo'? '操作日志' : ''"
    @hanldeLog="getModifiedRecord"
    :logData='LogItems'
    >
      <div slot="content">
        <lk-form
          :model="roleForm.sysRole"
          label-position="right"
          :label-width="130"
          :rules="ruleValidate"
          ref="roleForm.sysRole"
        >
          <div class="cardContainer">
            <lk-card title="角色信息">
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="角色名称:" prop="name">
                    <lk-input :maxlength='20' placeholder='请输入' :clearable="$route.name !== 'roleEdit'" v-model.trim="roleForm.sysRole.name" v-if="able" :disabled="$route.name === 'roleEdit'"></lk-input>
                    <span v-else>{{roleForm.sysRole.name}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="角色类型:" prop="type">
                    <lk-select
                      v-model.trim="roleForm.sysRole.type"
                      v-if="able"
                      :disabled="$route.name === 'roleEdit'"
                      @on-change="onTypeChanged"
                      >
                      <lk-option v-for="(item,index) in roleType" :value="index+1" :key="index+1">
                        {{item}}
                      </lk-option>
                    </lk-select>
                    <span v-else>{{roleType[roleForm.sysRole.type - 1]}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col>
                  <span class="ivu-form-item-error-tip"
                  style="position:absolute;top:5px;left:250px;z-index:999"
                  v-if="permissionError">
                    请至少勾选一个权限信息
                  </span>
                  <lk-form-item label="权限设置:"
                  prop="sysRouterList"
                  class="ivu-form-item-required">
                    <div class="treeFormat">
                      <lk-tree show-checkbox multiple :data="roleRights" @on-check-change='getTreeData'>
                      </lk-tree>
                    </div>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
        </lk-form>
      </div>
    </BaseFrame>
    <DTPModal
    v-model="showClear"
    @confirm='confirmClear'
    content='重置将取消当前所做更改。'
    ></DTPModal>
  </div>
</template>

<script>
import BaseFrame from '@/components/frame/BaseFrame.vue';
import system from '@/services/system';
import utils from '@/libs/utils';
import DTPModal from '@/components/DTPModal.vue';

export default {
  components: {
    BaseFrame,
    DTPModal,
  },
  data() {
    const nameTest = (rule, value, callback) => { // 角色名称远程验证重复
      if (this.$route.name === 'roleEdit') {
        callback();
      } else {
        system.roleNameCheck({ name: value }).then((res) => {
          if (res.data.status === 200) {
            callback();
          } else {
            callback(new Error(res.data.error));
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      }
    };

    return {
      roleId: '',
      idText: '',
      showClear: false,
      roleRights: [],
      able: true,
      infos: null,
      modifiedRecords: [],
      logShow: false,
      permissionError: false,
      LogItems: [],
      roleType: ['总部角色', '门店角色'],
      roleForm: {
        sysRole: {
          id: '',
          name: '',
          type: 0,
        },
        permissionIdList: [],
        sysRouterList: [],
      },
      ruleValidate: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { validator: nameTest, trigger: 'blur' },
        ],
        type: [
          {
            required: true, message: '请选择角色类型', type: 'number', trigger: 'blur',
          },
        ],

      },
    };
  },
  methods: {
    showLogInfo() {
      this.logShow = true;
    },
    onTypeChanged() {
      this.sysRouterList = [];
      this.getRightList();
    },
    confirmClear() {
      if (this.$route.name === 'roleAdd') {
        this.roleForm = {
          sysRole: {
            id: this.roleId,
            name: '',
            type: 0,
          },
          permissionIdList: [],
          sysRouterList: [],
        };
      }
      this.initData();
      this.showClear = false;
    },
    getTreeData(val) {
      if (val !== '') {
        const tempArray = [];
        for (let i = 0; i < val.length; i++) {
          if (val[i].pid !== val[i].id && val[i].pid !== 0) {
            tempArray.push({ id: val[i].id, pid: val[i].pid });
          }
        }
        this.roleForm.sysRouterList = [];
        this.roleForm.sysRouterList = [...tempArray];
      }
    },
    exchageTree(data, result) {
      data.map((val) => {
        let item = null;
        const judge = this.roleForm.permissionIdList.includes(val.sysRouter.id);
        item = {
          title: val.sysRouter.title,
          id: val.sysRouter.id,
          pid: val.sysRouter.pid,
          disabled: !this.able,
          expand: true,
          checked: judge,
        };
        if (val.childMenu && val.childButton) {
          item.children = [];
          this.exchageTree(val.childMenu, item.children);
          this.exchageTree(val.childButton, item.children);
        } else if (val.childMenu && !val.childButton) {
          item.children = [];
          this.exchageTree(val.childMenu, item.children);
        } else if (!val.childMenu && val.childButton) {
          item.children = [];
          this.exchageTree(val.childButton, item.children);
        }
        result.push(item);
      });
    },
    setAble(val) {
      this.able = val;
      if (!this.able) {
        this.$set(this.ruleValidate, null);
        this.ruleValidate = null;
      }
    },
    getInfo() {
      return system.roleInfo({ id: this.roleId }).then((res) => {
        if (res.data.status === 200) {
          const resData = res.data.data;
          this.idText = '角色ID';
          this.infos = {
            id: resData.sysRole.id,
            createUserName: resData.sysRole.createUserName,
            createTime: utils.formatTime(resData.sysRole.createTime),
            modifiedUserName: resData.sysRole.modifiedUserName,
            modifiedTime: utils.formatTime(resData.sysRole.modifiedTime),
          };
          resData.sysRouterList && resData.sysRouterList.forEach((val) => {
            this.roleForm.permissionIdList.push(val.id);
            this.roleForm.sysRouterList.push({ id: val.id, pid: val.pid });
          });
          this.roleForm.sysRole = resData.sysRole;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    compare(property) {
      return (a, b) => {
        const value1 = a[property];
        const value2 = b[property];
        return value1 - value2;
      };
    },
    // 获取权限列表
    getRightList() {
      const params = {
        type: this.roleForm.sysRole.type,
      };
      system.getRightList(params).then((res) => {
        const { data } = res.data;
        if (res.data.status === 200) {
          this.roleRights = [];
          this.exchageTree(data, this.roleRights);
          this.roleRights.sort(this.compare('id'));
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    submit(name) { // 验证函数
      if (this.roleForm.sysRouterList.length === 0) {
        this.permissionError = true;
      } else {
        this.permissionError = false;
      }
      this.$refs[name].validate((valid) => {
        if (valid && !this.permissionError) {
          const addFunc = this.$route.name === 'roleEdit' ? system.roleUpdate : system.roleSave;
          addFunc(this.roleForm).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('保存成功');
              setTimeout(() => {
                this.$router.push({ name: 'roleList', params: { create: this.$route.name !== 'roleEdit' } });
              }, 1000);
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        } else {
          this.$Message.error('请按照要求填写!');
        }
      });
    },
    getModifiedRecord() {
      system.getRoleModifitimeRecord({ id: this.roleId }).then((res) => {
        if (res.data.status === 200) {
          this.LogItems = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    initData() {
      if (this.$route.name !== 'roleAdd') {
        this.roleId = this.$route.params.id;
        this.getInfo().then(() => {
          this.getRightList();
        });
      } else {
        this.roleForm.sysRole.type = 1;
        this.getRightList();
      }
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
<style lang="less" scoped>
.cardContainer {
  margin-bottom: 16px;
}
.label {
  text-align-last: right;
  text-align: right;
  margin-left: -142px;
  width: 130px;
  float: left;
  line-height: 1;
}
.label:before {
  content: "";
  display: inline;
  border: 1px solid #1890ff;
  margin-right: 8px;
}
.p-font{
  padding: 0 10px;
  margin-bottom: 10px;
}
</style>
